/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import _ from 'lodash'
// import * as routes from 'Router/routes'

export default function*({ payload }) {
  if (_.get(payload, 'response.data.code') === 'UserNotConfirmedException') {
    const jsonData = _.get(payload, 'config.data')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const data = JSON.parse(jsonData)
    yield
  }
}
